import {
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";
import React, { Suspense } from "react";
import { createPortal } from "react-dom";
import { constants } from "../api/constants";

// import ComponentPageLoader from '../shared-components/page-loader/index';

import LogoLoader from "../shared-components/page-loader/logoLoader";
import ButterflyMark from "../shared-components/page-loader/butterflyMark";
import { connect } from "react-redux";
import _ from "lodash";
import { getRoles } from "../actions/MasterDataActions/AccountAction";
import {
  CONTENT_ADMIN,
  CONTENT_AUTHOR,
  SYSTEM_ADMIN,
  TKL_ACCOUNT_MANAGER,
  TKL_COMMUNITY_MANAGER,
  TKL_FACILITATOR,
  DISTRICT_ADMIN,
  SCHOOL_ADMIN,
  DISTRICT_FACILITATOR,
  SCHOOL_FACILITATOR,
} from "../constants.js/RoleNames";
import { PROGRAM_CATALOG_ROLES, ANY_PROGRAM_CATALOG_ROLES } from "../components/utility/ReUsableFunctions";

/**
 * Profile `roles` should be a string[] of those enum values; normalize "", objects, or single string.
 */
function normalizeUserRoles(raw) {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) {
    return raw
      .map((r) => {
        if (typeof r === "string") return r.trim();
        if (r && typeof r === "object") {
          const v =
            r.name ??
            r.label ??
            r.roleName ??
            r.role ??
            r.slug ??
            r.title;
          return typeof v === "string" ? v.trim() : "";
        }
        return "";
      })
      .filter(Boolean);
  }
  if (typeof raw === "string") {
    const t = raw.trim();
    return t ? [t] : [];
  }
  return [];
}

function userHasAnyRole(rawRoles, allowedRoleStrings) {
  const list = normalizeUserRoles(rawRoles);
  return list.some((r) => allowedRoleStrings.includes(r));
}
import { userRoles, isFreeUser, roleList } from "../components/utility/ReUsableFunctions";
import { PublicGtm } from "../components/analytics/PublicGtm";

//import CreateCourse from '../components/CourseCreation/CreateCourse';
//import CoursePath from "../components/CoursePath/CoursePath";

const ContentAdmin = React.lazy(
  () => import("../components/Dashboards/ContentAdmin")
);
const ContentAuthor = React.lazy(
  () => import("../components/Dashboards/ContentAuthor")
);
const NotFoundPage = React.lazy(
  () => import("../components/OtherPages/NotFoundPage")
);
const CoursePathReport = React.lazy(
  () => import("../components/Instructor/coursePathReport/CoursePathReport")
);
const FileStorageRoot = React.lazy(
  () => import("components/FileStorage/FileStorageRoot")
);
const UnderMaintenance = React.lazy(
  () => import("../components/UnderMaintenance/UnderMaintenance")
);
const ListOfResources = React.lazy(
  () => import("components/community/Resources/ListOfResources")
);
const ListOfColleages = React.lazy(
  () => import("components/community/ProfessionalColleagues/ListOfColleages")
);
const UpdateCohortMembers = React.lazy(
  () =>
    import(
      "components/Cohorts/ManageCohortForAccount/UpdateMicroCohortMembers"
    )
);
const Rewards = React.lazy(
  () => import("components/Gamification/Rewards/Rewards")
);
const Challenges = React.lazy(
  () => import("../components/Gamification/Challenges/Challenges")
);

const TKLReports = React.lazy(
  () => import("../components/TKLReports/TKLReports")
);
const PageDefault = React.lazy(() => import("../pages/default/index"));
// const PageLogin = React.lazy(() => import('../pages/login/index'));
const PageLogin = React.lazy(() => import("../components/UserLogin/login"));

const PageChangePassword = React.lazy(
  () => import("../components/UserProfile/ChangePassword")
);

//const PageCreateCourse = React.lazy(() => import('../pages/create-course/index'));
const PageCourseReview = React.lazy(
  () => import("../components/Instructor/IntructorDashboard")
);
const PageCourseReviewGPLCMICRO = React.lazy(
  () => import("../components/Instructor/IntructorDashboardMicroGPLC")
);
const PageCourseReviewMICRO = React.lazy(
  () => import("../components/Instructor/InstructorDashboardMicro")
);

const PageCourseReviewKidvision = React.lazy(
  () => import("../components/Instructor/InsructorDashboardKidvision")
);

const PageCourseReviewOld = React.lazy(
  () => import("../pages/course-review/index")
);
const PageCoursePath = React.lazy(() => import("../pages/course-path/index"));
const PageManageCohorts = React.lazy(
  () =>
    import(
      "../components/Cohorts/ManageCohortForAccount/ManageCohortForAccount"
    )
);
const PageManageMembers = React.lazy(
  () => import("../pages/manage-members/index")
);
const CatalogComprehensive = React.lazy(
  () => import("../components/Catalog/Comprehensive/CatalogComprehensive")
);
const CatalogMicro = React.lazy(()=> import("../components/Catalog/Micro/CatalogMicro" ));

const CatalogKidVision = React.lazy(()=> import("../components/Catalog/KidVision/CatalogKidVision" ));

const PageCart = React.lazy(() => import("../pages/cart/index"));
const PageCatalogGPLC = React.lazy(
  () => import("../components/Catalog/GPLCCatalog/GPLCCatalog")
);
const PageCatalogMicro = React.lazy(
  () => import("../pages/catalog/index-micro")
);
const PageCommunity = React.lazy(() => import("../components/community/index"));
const PageCommunityOld = React.lazy(() => import("../pages/community/index"));
const PageColleagues = React.lazy(
  () =>
    import(
      "../components/community/ProfessionalColleagues/ProfessionalColleagues"
    )
);

const PageActivitypathOld = React.lazy(
  () => import("../pages/activity-path/index")
);
const PageActivitypath = React.lazy(
  () => import("../components/ActivityPath/ActivityEdit")
);
const PageCreateCourse = React.lazy(
  () => import("../components/CourseCreation/CreateCourse")
);
const CourseHomePage = React.lazy(
  () => import("../components/CourseCreation/CourseHomePage")
);
const LearnerHome = React.lazy(
  () => import("../components/Leaner/LeanderHome")
);
const CoursePath = React.lazy(
  () => import("../components/CoursePath/CoursePath")
);
const MasterData = React.lazy(
  () => import("../components/MasterData/MasterData")
);
const TKLAdmin = React.lazy(() => import("../components/TKLAdmin/TKLAdmin"));

const CourseDevelopmentStatus = React.lazy(
  () => import("../components/CourseDevelopmentStatus/CourseDevelopmentStatus")
);
const ManageCohorts = React.lazy(
  () => import("../components/Cohorts/ManageCohorts/ManageCohorts")
);
const Cohorts = React.lazy(() => import("../components/Cohorts/Cohorts"));
const DraftRichText = React.lazy(
  () => import("../components/DraftRichTextEditor/DraftRichTextEditor")
);

const CatalogWebsite = React.lazy(
  () => import("../components/Catalog/Website/CatalogWebsite")
);

const BundleCodes = React.lazy(
  () => import("../components/Catalog/Comprehensive/BundleCodes")
);

const ExternalBundleCodes = React.lazy(
  () => import("../components/Catalog/Website/ExternalBundleCodes")
);
const Register = React.lazy(
  () => import("../components/UserRegister/Register")
);
const ProfileCreate = React.lazy(
  () => import("../components/UserProfile/CreateProfile/CreateProfileRootPage")
);
const ProfileData = React.lazy(
  () => import("../components/UserProfile/ProfileBio/ProfileData")
);
const MainCart = React.lazy(
  () => import("../components/Catalog/Cart/MainCart")
);
const MainCartWebsite = React.lazy(
  () => import("../components/Catalog/CartWebsite/MainCartWebsite")
);

const InformationSheets = React.lazy(
  () => import("../components/InformationSheets/InformationSheets")
);

const PreviousPolls = React.lazy(
  () => import("../components/community/MontlyPolls/AllMonthPolls")
);
const AllDiscussionForums = React.lazy(
  () =>
    import(
      "../components/dashboard-tile/tiles/AllDisucssionForums/AllDiscussionForums"
    )
);

const LeaderboardPage = React.lazy(() => import('../pages/leaderboard'));
const BadgesPage = React.lazy(() => import('../pages/badges'));
const FAQPage = React.lazy(() => import('../pages/faq'));

function RouteSuspenseFallback({ suppress }) {
  if (suppress) return null;
  return <LogoLoader />;
}

// JS default export; React.lazy() drops extra props from the inferred type.
const LoopPageCommunity = PageCommunity as React.ComponentType<{
  onFeedReady?: () => void;
}>;

const RewardsPage = Rewards as React.ComponentType<{
  onRewardsReady?: () => void;
}>;

const ChallengesPage = Challenges as React.ComponentType<{
  onChallengesReady?: () => void;
}>;

const DashboardPage = ContentAdmin as React.ComponentType<{
  onDashboardReady?: () => void;
}>;

const ColleaguesPage = PageColleagues as React.ComponentType<{
  onColleaguesReady?: () => void;
}>;

const BadgesPageReady = BadgesPage as React.ComponentType<{
  onBadgesReady?: () => void;
}>;

const FaqPageReady = FAQPage as React.ComponentType<{
  onFaqReady?: () => void;
}>;

function FullPageButterflyLoader({
  message,
  mainClassName = "pg-main com-page",
}: {
  message: string;
  mainClassName?: string;
}) {
  // useLayoutEffect so footer is hidden before the browser paints (avoids footer flash).
  React.useLayoutEffect(() => {
    const html = document.documentElement;
    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlHeight = html.style.height;
    const previousBodyHeight = document.body.style.height;
    html.classList.add("tkl-route-loading");
    html.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    html.style.height = "100%";
    document.body.style.height = "100%";
    return () => {
      html.classList.remove("tkl-route-loading");
      html.classList.remove("tkl-boot-route-loader");
      html.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
      html.style.height = previousHtmlHeight;
      document.body.style.height = previousBodyHeight;
    };
  }, []);

  return (
    <>
      <style>
        {`html,body{overflow:hidden !important;height:100% !important;width:100% !important}
          html.tkl-route-loading .sitefooter-comp,
          html.tkl-boot-route-loader .sitefooter-comp,
          body .sitefooter-comp{display:none !important}
          html.tkl-route-loading .tkl-footer,
          html.tkl-boot-route-loader .tkl-footer,
          body .tkl-footer{display:none !important}
          /* Match Loop: pin overlay to the viewport edges (not 100vw, which can undershoot). */
          body > .page-loader-comp.tkl-fullpage-butterfly-loader{
            position:fixed !important;
            inset:0 !important;
            top:0 !important;right:0 !important;bottom:0 !important;left:0 !important;
            width:auto !important;
            max-width:none !important;
            height:auto !important;
            min-height:100% !important;
            min-height:100dvh !important;
            margin:0 !important;
            z-index:10000 !important;
            /* Don't fade in — opacity:0 would let the footer show through. */
            opacity:1 !important;
            transition:none !important;
          }`}
      </style>
      <main
        className={mainClassName}
        style={{ height: "100dvh", minHeight: "100vh", width: "100%" }}
      />
      {createPortal(
        <div
          className="page-loader-comp active tkl-fullpage-butterfly-loader"
          style={{
            position: "fixed",
            zIndex: 10000,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            // Same as The Loop: inset stretch — width/height auto fills the viewport.
            width: "auto",
            height: "auto",
            opacity: 1,
          }}
        >
          <div className="text-center">
            <ButterflyMark />
            <p className="mt-3 mb-0" style={{ color: "rgba(255, 255, 255, 0.85)" }}>
              {message}
            </p>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

// One in-page loader. The page stays hidden until the feed is ready so a
// full-screen overlay does not play first and then restart on the page.
function LoopRoute() {
  const [feedReady, setFeedReady] = React.useState(false);
  const markFeedReady = React.useCallback(() => {
    setFeedReady(true);
  }, []);

  return (
    <React.Fragment>
      {!feedReady && (
        <FullPageButterflyLoader
          message="Loading posts..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={feedReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <LoopPageCommunity onFeedReady={markFeedReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly until rewards dashboard data is ready.
function RewardsRoute() {
  const [rewardsReady, setRewardsReady] = React.useState(false);
  const markRewardsReady = React.useCallback(() => {
    setRewardsReady(true);
  }, []);

  return (
    <React.Fragment>
      {!rewardsReady && (
        <FullPageButterflyLoader
          message="Loading rewards..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={rewardsReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <RewardsPage onRewardsReady={markRewardsReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly until challenges data is ready.
function ChallengesRoute() {
  const [challengesReady, setChallengesReady] = React.useState(false);
  const markChallengesReady = React.useCallback(() => {
    setChallengesReady(true);
  }, []);

  return (
    <React.Fragment>
      {!challengesReady && (
        <FullPageButterflyLoader
          message="Loading challenges..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={challengesReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <ChallengesPage onChallengesReady={markChallengesReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly until colleagues list data is ready.
function ColleaguesRoute() {
  const [colleaguesReady, setColleaguesReady] = React.useState(false);
  const markColleaguesReady = React.useCallback(() => {
    setColleaguesReady(true);
  }, []);

  return (
    <React.Fragment>
      {!colleaguesReady && (
        <FullPageButterflyLoader
          message="Loading colleagues..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={colleaguesReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <ColleaguesPage onColleaguesReady={markColleaguesReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly until badges data is ready.
function BadgesRoute() {
  const [badgesReady, setBadgesReady] = React.useState(false);
  const markBadgesReady = React.useCallback(() => {
    setBadgesReady(true);
  }, []);

  return (
    <React.Fragment>
      {!badgesReady && (
        <FullPageButterflyLoader
          message="Loading badges..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={badgesReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <BadgesPageReady onBadgesReady={markBadgesReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly until FAQ data is ready.
function FaqRoute() {
  const [faqReady, setFaqReady] = React.useState(false);
  const markFaqReady = React.useCallback(() => {
    setFaqReady(true);
  }, []);

  return (
    <React.Fragment>
      {!faqReady && (
        <FullPageButterflyLoader
          message="Loading FAQs..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={faqReady ? undefined : { display: "none" }}>
        <Suspense fallback={null}>
          <FaqPageReady onFaqReady={markFaqReady} />
        </Suspense>
      </div>
    </React.Fragment>
  );
}

// Same pattern: one butterfly for the full window from first paint
// (including while roles are still loading) until tiles are ready.
function DashboardRoute({ canMount }: { canMount: boolean }) {
  const [dashboardReady, setDashboardReady] = React.useState(false);
  const markDashboardReady = React.useCallback(() => {
    setDashboardReady(true);
  }, []);

  const showOverlay = !(canMount && dashboardReady);

  return (
    <React.Fragment>
      {showOverlay && (
        <FullPageButterflyLoader
          message="Loading dashboard..."
          mainClassName="pg-main com-page"
        />
      )}
      <div style={!showOverlay ? undefined : { display: "none" }}>
        {canMount ? (
          <Suspense fallback={null}>
            <DashboardPage onDashboardReady={markDashboardReady} />
          </Suspense>
        ) : null}
      </div>
    </React.Fragment>
  );
}

const MainRoutes = (props) => {
  const roles = roleList(props.userData?.roles);
  const { pathname } = useLocation();
  const sessionReady =
    !!localStorage.getItem("token") &&
    localStorage.getItem("isTemporaryPassword") === "false";

  // Profile/bio is loaded via App store.dispatch(getProfileData) into this Provider (PL-10/27).

  // const getComponentBasedOnRole = () => {
  //     // if(roles.length>0){
  //     //     if(roles?.includes("TKL CONTENT ADMIN")){
  //     //         return <ContentAdmin />;
  //     //     }else if(roles?.includes("CONTENT AUTHOR")){
  //     //         return <ContentAuthor />;
  //     //     }else{
  //     //         return <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}><PageDefault /></Suspense>;
  //     //     }
  //     // }else{
  //     //     return <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}><PageDefault /></Suspense>;
  //     // }
  //     return <ContentAdmin />;
  // }

  //  console.log("currentRoles:::",roles);
  const PrivateRoute = ({ children, currentRoles, ...rest }) => {
    return (
      <Route
        {...rest}
        render={() => {
          return userHasAnyRole(roles, currentRoles) ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        }}
      />
    );
  };
  const authenticatedUser = () => {
    return (
      // <HashRouter>
      <Switch>
        <Route exact path="/see_all">
          <PageDefault />
        </Route>
        <Route exact path="/informationSheets">
          <InformationSheets />
        </Route>
        <Route exact path="/register">
          <PublicGtm>
            <Register />
          </PublicGtm>
        </Route>
        <Route exact path="/forgotPassword">
          <PageLogin />
        </Route>
        <Route exact path="/changePassword">
          <PageLogin />
        </Route>
        <Route exact path="/courseHomePage">
          <CourseHomePage />
        </Route>
        <Route exact path="/toCart">
          <MainCart />
        </Route>
        <Route exact path="/toCartWebsite">
          <PublicGtm>
            <MainCartWebsite />
          </PublicGtm>
        </Route>
        <Route exact path="/tklAdmin/account/:accountId">
          <TKLAdmin />
        </Route>
        <Route exact path="/tklAdmin">
          <TKLAdmin />
        </Route>
        <Route exact path="/tklReports">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <TKLReports />
          </Suspense>
        </Route>
        <Route exact path="/instructorHomePage">
          <LearnerHome />
        </Route>
        <Route exact path="/learnerHomePage">
          <LearnerHome />
        </Route>
        <Route exact path="/createProfile">
          <ProfileCreate />
        </Route>
        <Route exact path="/profileData">
          <ProfileData />
        </Route>
        <Route exact path="/OtherProfile/:userSlugId">
          <ProfileData />
        </Route>
        <Route exact path="/external-catalog">
          <PublicGtm>
            <CatalogWebsite />
          </PublicGtm>
        </Route>
        <Route exact path="/manageCohorts">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ManageCohorts />
          </Suspense>
        </Route>
        <Route exact path="/manageCohorts/:programType">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ManageCohorts />
          </Suspense>
        </Route>
        <Route exact path="/changeTempPassword">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageChangePassword />
          </Suspense>
        </Route>
        <Route exact path="/courseDevelopmentStatus">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CourseDevelopmentStatus />
          </Suspense>
        </Route>
        <Route exact path="/CoursePath">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CoursePath />
          </Suspense>
        </Route>
        <Route exact path="/:id/CoursePath">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CoursePath />
          </Suspense>
        </Route>
        <Route exact path="/masterData">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <MasterData />
          </Suspense>
        </Route>
        <PrivateRoute
          currentRoles={[CONTENT_ADMIN, SYSTEM_ADMIN, TKL_ACCOUNT_MANAGER, TKL_COMMUNITY_MANAGER]}
          exact
          path="/leaderboard"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <LeaderboardPage />
          </Suspense>
        </PrivateRoute>

        {/* /badges is rendered above so its loader stays mounted across profile load */}

        {/* /faq is rendered above so its loader stays mounted across profile load */}

        <PrivateRoute
          currentRoles={[CONTENT_ADMIN, SYSTEM_ADMIN, TKL_ACCOUNT_MANAGER, TKL_COMMUNITY_MANAGER]}
          exact
          path="/leaderboards"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <LeaderboardPage />
          </Suspense>
        </PrivateRoute>
        {/*
        <Route exact path="/rewards">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <RewardManager />
          </Suspense>
        </Route>
        */}
        
        <Route exact path="/DraftRichText">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <DraftRichText />
          </Suspense>
        </Route>
        <Route
          exact
          path="/introductionActivity/:courseSlugId/CoursePath/:activitySlugId/:introId/activity-path/:mode"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/fragmentsActivity/:courseSlugId/CoursePath/:activitySlugId/activity-path/:mode"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/cohortIntroduction/:cohortActivity/:cohortId/introduction/:introId/:activityIndex/:activitySlugId"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/cohortIntroduction/:cohortActivity/:cohortId/introduction/:introId/:activityIndex/:activitySlugId/cohortUserLearner/:cohortUserLearner"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/cohortIntroduction/:cohortActivity/:cohortId/introduction/:introId/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/cohortIntroduction/:cohortActivity/:cohortId/introduction/:introId/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug/:cohortInstructorReadOnly"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        {/* for participantReport */}
        <Route
          exact
          path="/cohortIntroduction/:cohortActivity/:cohortId/introduction/:introId/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug/:cohortInstructorReadOnly/:participantReport"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/:cohortActivity/:cohortId/:moduleIndex/:sectionIndex/:activityIndex/:activitySlugId/cohortUserLearner/:cohortUserLearner"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/:cohortActivity/:cohortId/:moduleIndex/:sectionIndex/:activityIndex/:activitySlugId"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/:cohortActivity/:cohortId/:moduleIndex/:sectionIndex/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        <Route
          exact
          path="/:cohortActivity/:cohortId/:moduleIndex/:sectionIndex/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug/:cohortInstructorReadOnly"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        {/* for participantReport */}
        <Route
          exact
          path="/:cohortActivity/:cohortId/:moduleIndex/:sectionIndex/:activityIndex/:activitySlugId/cohortInstructor/:cohortInstructor/:userSlug/:cohortInstructorReadOnly/:participantReport"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            {" "}
            <PageActivitypath />
          </Suspense>
        </Route>
        {/* fot cohort user direct quiz*/}
        <Route exact path="/CoursePathForCohort/:id/:isLearner">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CoursePath />
          </Suspense>
        </Route>
        <Route exact path="/CoursePathForCohort/:id">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CoursePath />
          </Suspense>
        </Route>
        <Route exact path="/CoursePathReport/:courseSlug/:cohortId/:userSlug">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CoursePathReport />
          </Suspense>
        </Route>
        {/* <Route path="/redirect/:courseSlugId/CoursePath/:activitySlugId/activity-path/:mode">
            <PageActivitypath />
        </Route> */}
        <Route exact path="/:id/create-course">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCreateCourse />
          </Suspense>
        </Route>
        <Route exact path="/loginPage">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageLogin />
          </Suspense>
        </Route>
        {/* PL-40: legacy role dashboards redirect to ContentAdmin home on `/` */}
        <Redirect exact from="/dashboard-paid-user" to="/" />
        <Redirect exact from="/dashboard-district-admin" to="/" />
        <Redirect exact from="/dashboard-account-manager" to="/" />
        <Redirect exact from="/dashboard-course-facilitator" to="/" />
        <Redirect exact from="/dashboard-district-facilitator" to="/" />
        <Redirect exact from="/dashboard-school-facilitator" to="/" />
        <Redirect exact from="/dashboard-instructional-coach" to="/" />
        <Redirect exact from="/dashboard-system-admin" to="/" />
        <Route exact path="/content-admin">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ContentAdmin />
          </Suspense>
        </Route>
        <Route exact path="/content-author">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ContentAuthor />
          </Suspense>
        </Route>
        {/* <Route path="/editmyprofile">
            <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}><PageMyProfile /></Suspense>
        </Route> */}
        <Route exact path={`/${constants.pages.CREATE_COURSE}`}>
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCreateCourse />
          </Suspense>
        </Route>
        <Route exact path={`/${constants.pages.UPDATE_COURSE}`}>
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCreateCourse />
          </Suspense>
        </Route>
        <Route exact path="/course-review">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReview />
          </Suspense>
        </Route>
        <Route exact path="/course-review/:isDirectCourseReviewPage">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReview />
          </Suspense>
        </Route>
        <Route exact path="/course-review-gplc">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReviewGPLCMICRO />
          </Suspense>
        </Route>
        <Route exact path="/course-review-micro">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReviewMICRO />
          </Suspense>
        </Route>
        <Route exact path="/course-review-kidvision">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReviewKidvision />
          </Suspense>
        </Route>
        <Route exact path="/course-review-old">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCourseReviewOld />
          </Suspense>
        </Route>
        <Route exact path="/course-path/:mode">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCoursePath />
          </Suspense>
        </Route>
        <Route exact path="/activity-path/:mode">
          <PageActivitypath />
        </Route>
        
        <Route exact path="/activity-path-old/:mode">
          <PageActivitypathOld />
        </Route>

        <Route exact path="/updateMicroCohortMember/:accountId/:schoolId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <UpdateCohortMembers />
          </Suspense>
        </Route>

        <Route exact path="/updateKidVisionCohortMember/:accountId/:schoolId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <UpdateCohortMembers />
          </Suspense>
        </Route>


        <PrivateRoute
          currentRoles={[CONTENT_ADMIN, SYSTEM_ADMIN, TKL_ACCOUNT_MANAGER]}
          exact
          path="/manage-cohorts/"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageManageCohorts />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          currentRoles={[
            CONTENT_ADMIN,
            SYSTEM_ADMIN,
            TKL_FACILITATOR,
            CONTENT_AUTHOR,
          ]}
          exact
          path="/fileStorage"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <FileStorageRoot />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          currentRoles={[CONTENT_ADMIN, SYSTEM_ADMIN, TKL_ACCOUNT_MANAGER, DISTRICT_ADMIN, SCHOOL_ADMIN, DISTRICT_FACILITATOR, SCHOOL_FACILITATOR,]}
          exact
          path="/manage-cohorts/:mode"
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageManageCohorts />
          </Suspense>
        </PrivateRoute>
        <Route exact path="/manage-members">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageManageMembers />
          </Suspense>
        </Route>
        <Route exact path="/catalog-comprehensive">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CatalogComprehensive />
          </Suspense>
        </Route>
        <PrivateRoute
          exact
          path="/catalog-micro"
          currentRoles={PROGRAM_CATALOG_ROLES.micro}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CatalogMicro />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          exact
          path="/catalog-KidVision"
          currentRoles={PROGRAM_CATALOG_ROLES.kidvision}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <CatalogKidVision />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          exact
          path="/catalog-gplc"
          currentRoles={PROGRAM_CATALOG_ROLES.gplc}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCatalogGPLC />
          </Suspense>
        </PrivateRoute>
        <Route exact path="/bundle-codes">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <BundleCodes />
          </Suspense>
        </Route>
        <Route exact path="/cart-comprehensive/:codeapplied">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCart />
          </Suspense>
        </Route>
        <PrivateRoute
          exact
          path="/catalog/:mode/:accountId/:schoolId/:cohortGroupId"
          currentRoles={ANY_PROGRAM_CATALOG_ROLES}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCatalogGPLC />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          exact
          path="/dashboard/catalog/:mode/"
          currentRoles={ANY_PROGRAM_CATALOG_ROLES}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCatalogGPLC />
          </Suspense>
        </PrivateRoute>
        <PrivateRoute
          exact
          path="/catalog"
          currentRoles={PROGRAM_CATALOG_ROLES.gplc}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCatalogGPLC />
          </Suspense>
        </PrivateRoute>
        {/* /colleagues is rendered above so its loader stays mounted across profile load */}
        <PrivateRoute
          exact
          path="/catalog-micro/:role"
          currentRoles={PROGRAM_CATALOG_ROLES.micro}
        >
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCatalogMicro />
          </Suspense>
        </PrivateRoute>
        {/* /the-loop is rendered above so its loader stays mounted across profile load */}
        {/* Redirects from old community URLs */}
        <Route exact path="/community">
          <Redirect to="/the-loop" />
        </Route>
        {/* /rewards is rendered above so its loader stays mounted across profile load */}
        <Route exact path="/the-loop/:groupId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCommunity />
          </Suspense>
        </Route>
        <Route exact path="/community/:groupId">
          <Redirect to="/the-loop" />
        </Route>
        <Route exact path="/the-loop/:groupId/add-colleagues">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ListOfColleages />
          </Suspense>
        </Route>
        <Route exact path="/community/:groupId/add-colleagues">
          <Redirect to="/the-loop" />
        </Route>
        <Route exact path="/the-loop/resources/all-tkl-recommended-resouces">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <ListOfResources />
          </Suspense>
        </Route>
        <Route exact path="/community/resources/all-tkl-recommended-resouces">
          <Redirect to="/the-loop/resources/all-tkl-recommended-resouces" />
        </Route>
        <Route exact path="/the-loop/forum/:forumId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCommunity />
          </Suspense>
        </Route>
        <Route exact path="/community/forum/:forumId">
          <Redirect to="/the-loop" />
        </Route>
        <Route exact path="/the-loop/PostItem/:bookmarkPostId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCommunity />
          </Suspense>
        </Route>
        <Route 
          exact 
          path="/community/PostItem/:bookmarkPostId"
          render={({ match }) => (
            <Redirect to={`/the-loop/PostItem/${match.params.bookmarkPostId}`} />
          )}
        />
        <Route exact path="/all_polls">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PreviousPolls />
          </Suspense>
        </Route>
        <Route exact path="/community-old">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageCommunityOld />
          </Suspense>
        </Route>
        <Route exact path="/default">
          <Redirect to="/" />
        </Route>
        <Route exact path="/:courseSlug/:programSelected/cohorts">
          <Cohorts />
        </Route>
        <Route exact path="/discussionForums/:cohortId">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <AllDiscussionForums />
          </Suspense>
        </Route>
        <Route exact path="/">
          {isFreeUser(roles) ? (
            <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
              <PageCommunity />
            </Suspense>
          ) : (
            <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
              <ContentAdmin />
            </Suspense>
          )}
        </Route>
        {/* /challenges is rendered above so its loader stays mounted across profile load */}
        <Route path="*">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <NotFoundPage />
          </Suspense>
        </Route>
        
      </Switch>
    );
  };
  const unauthenticatedUser = () => {
    return (
      <Switch>
        <Route path="/see_all">
          <PageDefault />
        </Route>

        <Route exact path="/register">
          <PublicGtm>
            <Register />
          </PublicGtm>
        </Route>

        <Route path="/forgotPassword">
          <PageLogin />
        </Route>

        <Route exact path="/changeTempPassword">
          <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
            <PageChangePassword />
          </Suspense>
        </Route>

        <Route path="/changePassword">
          <PageLogin />
        </Route>

        <Route exact path="/external-catalog">
          <PublicGtm>
            <CatalogWebsite />
          </PublicGtm>
        </Route>

        <Route path="/external-bundlecodes">
          <ExternalBundleCodes />
        </Route>
        <Route exact path="/toCartWebsite">
          <PublicGtm>
            <MainCartWebsite />
          </PublicGtm>
        </Route>
        <Route path="*">
          <PageLogin />
        </Route>
      </Switch>
    );
  };
  return (
    <React.Fragment>
        <React.Fragment>
          {/* Special routes own a single butterfly overlay; skip stacking LogoLoader. */}
          {props.isLoading &&
            pathname !== "/the-loop" &&
            pathname !== "/rewards" &&
            pathname !== "/challenges" &&
            pathname !== "/colleagues" &&
            pathname !== "/badges" &&
            pathname !== "/faq" &&
            pathname !== "/" && <LogoLoader />}
          {!props.isUnderMaintenance ? (
            sessionReady ? (
              pathname === "/the-loop" ? (
                <LoopRoute />
              ) : pathname === "/rewards" ? (
                <RewardsRoute />
              ) : pathname === "/challenges" ? (
                <ChallengesRoute />
              ) : pathname === "/colleagues" ? (
                <ColleaguesRoute />
              ) : pathname === "/badges" ? (
                <BadgesRoute />
              ) : pathname === "/faq" ? (
                <FaqRoute />
              ) : pathname === "/" ? (
                !_.isEmpty(roles) && isFreeUser(roles) ? (
                  authenticatedUser()
                ) : (
                  <DashboardRoute
                    canMount={!_.isEmpty(roles) && !isFreeUser(roles)}
                  />
                )
              ) : (
                !_.isEmpty(roles) && authenticatedUser()
              )
            ) : (
              <>{unauthenticatedUser()}</>
            )
          ) : (
            <Switch>
              <Route path="*">
                <Suspense fallback={<RouteSuspenseFallback suppress={props.isLoading} />}>
                  <UnderMaintenance />
                </Suspense>
              </Route>
            </Switch>
          )}
        </React.Fragment>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.coursehome.isLoading,
    userData: state.users.userData,
    userRoles: state.tkladmin.roles,
  };
};
const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(MainRoutes);
